/**
 * Spotify is switched off - SpotifyService is commented out of the provider
 * tree in App.tsx (commit d99eb50). Everything that would have offered it to
 * the user checks this instead of assuming the provider is there.
 *
 * Without this the route and the settings button stayed wired up to a context
 * nobody provided: `SpotifyContext` fell back to its `{}` default, so
 * `onClick={spotifyCtx.authorize}` was `onClick={undefined}` and the button
 * did nothing at all - no request, no console line, no error. A control that
 * silently does nothing is worse than one that is not there.
 *
 * Flip this to true in the same commit that puts SpotifyService back.
 */
export const spotifyEnabled = false;
